import { StyleSheet} from "@react-pdf/renderer";

import { PRIMARY_BLACK } from "constants/globalConstants";
const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    border: 1,
    borderColor: PRIMARY_BLACK,
    borderStyle: "solid",
    marginHorizontal: 35
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10
  },
  headerDescription: {
    width: "60%",
    fontSize: 20,
    fontWeight: 700
  },
  headerAlarmId: {
    width: "40%",
    fontSize: 20,
    fontWeight: 700
  },
  tableRow: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10
  },
  description: {
    width: "60%"
  },
  alarmId: {
    width: "40%"
  }
});

export default styles;
